import Swiper from 'swiper';

export default function () {
    new Swiper('.c-brands__swiper', {
        slidesPerView: 2,
        spaceBetween: 30,
        watchOverflow: true,
        loop: true,
        autoplay: true,
        speed: 1000,
        breakpoints: {
            768: {
                slidesPerView: 4
            },
            1199: {
                slidesPerView: 5
            }
        }
    });
}
